import React, { useEffect, useState } from 'react'


// third party
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, Link } from "react-router-dom";
//redux
import { changeState } from '../redux/loading';
// utils
import { successMessage, errorMessage } from "../utils/toastMessage"


//component
import PageUrlGuid from '../component/pageUrlGuid';

//services
import { aboutUs, contactUs, service } from '../service/otherService'
import Footer from '../component/footer';
import Header from '../component/header';
import Seperator from '../component/seperator';

const Service = () => {
    //=========================================================== use hooks 
    const dispatch = useDispatch()
    const [getOther, setOther] = useState()

    //=========================================================== backend function
    const handelGetOther = async () => {
        dispatch(changeState(true))
        try {
            const { status, data } = await service();
            if (status === 200) {
                setOther(data.data)
                document.querySelector(".other").innerHTML = data.data.description
                dispatch(changeState(false))

            }

        } catch (ex) {
            errorMessage("مشکلی از سمت سرور پیش آمده")
            dispatch(changeState(false))
        }

    }

    useEffect(() => {
        handelGetOther()
    }, [])
    return (
        <>
            <Header />
            <PageUrlGuid>
                <Link to={"/"}>
                    صفحه اصلی
                </Link>
                <Seperator amount={5} />
                /
                <Seperator amount={5} />
                <h1>
                    خدمات
                </h1>
            </PageUrlGuid>

            <div className='other'>
            </div>
            <Footer />
        </>

    )
}


export default Service